import { render, staticRenderFns } from "./internal_files.vue?vue&type=template&id=3b464157&scoped=true&"
import script from "./internal_files.vue?vue&type=script&lang=js&"
export * from "./internal_files.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b464157",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b464157')) {
      api.createRecord('3b464157', component.options)
    } else {
      api.reload('3b464157', component.options)
    }
    module.hot.accept("./internal_files.vue?vue&type=template&id=3b464157&scoped=true&", function () {
      api.rerender('3b464157', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/internal_docs/inside/internal_files.vue"
export default component.exports